import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Inicio', id: 'hero' },
    { label: 'Sobre Nosotros', id: 'about' },
    { label: 'Servicios', id: 'services' },
    { label: 'Contacto', id: 'contact' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-lg' 
          : 'bg-white/90 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer group"
            onClick={() => scrollToSection('hero')}
          >
            <img 
              src="/logo-bramador-transparent.png" 
              alt="Bramador Logo" 
              className="h-12 sm:h-14 w-auto transition-all duration-300 group-hover:scale-105"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="px-4 py-2 text-slate-700 hover:text-[#01A9DB] font-medium transition-colors duration-200 rounded-lg hover:bg-cyan-50"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Contact Info - Desktop */}
          <div className="hidden md:flex items-center space-x-4">
            <a 
              href="tel:+56956500328"
              className="flex items-center space-x-2 text-slate-600 hover:text-[#01A9DB] transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span className="text-sm font-medium">+569 5650 0328</span>
            </a>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#F58020] hover:bg-[#ea580c] text-white"
            >
              Cotizar
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-slate-700" />
            ) : (
              <Menu className="w-6 h-6 text-slate-700" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-slate-200 animate-in slide-in-from-top duration-200">
            <nav className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="px-4 py-3 text-left text-slate-700 hover:text-[#01A9DB] hover:bg-cyan-50 rounded-lg transition-colors font-medium"
                >
                  {item.label}
                </button>
              ))}
              <div className="pt-4 px-4 flex flex-col space-y-3 border-t border-slate-200">
                <a 
                  href="tel:+56956500328"
                  className="flex items-center space-x-3 text-slate-600 hover:text-[#01A9DB] transition-colors"
                >
                  <Phone className="w-5 h-5" />
                  <span className="font-medium">+569 5650 0328</span>
                </a>
                <a 
                  href="mailto:contacto@bramador.cl"
                  className="flex items-center space-x-3 text-slate-600 hover:text-[#01A9DB] transition-colors"
                >
                  <Mail className="w-5 h-5" />
                  <span className="font-medium">contacto@bramador.cl</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
